export default "__VITE_ASSET__IZM8btPC__"